export const PRODUCT_SUBSTITUTES_FEATURE_KEY = 'product-substitutes';
